var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForwardArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.92 11.6154C17.8724 11.4927 17.801 11.3807 17.71 11.2856L12.71 6.28976C12.6168 6.1966 12.5061 6.1227 12.3842 6.07228C12.2624 6.02186 12.1319 5.99591 12 5.99591C11.7337 5.99591 11.4783 6.10161 11.29 6.28976C11.1968 6.38292 11.1228 6.49352 11.0723 6.61524C11.0219 6.73696 10.9959 6.86742 10.9959 6.99918C10.9959 7.26526 11.1017 7.52044 11.29 7.70859L14.59 10.9959H7C6.73478 10.9959 6.48043 11.1012 6.29289 11.2885C6.10536 11.4759 6 11.7301 6 11.9951C6 12.2601 6.10536 12.5142 6.29289 12.7016C6.48043 12.889 6.73478 12.9942 7 12.9942H14.59L11.29 16.2815C11.1963 16.3744 11.1219 16.4849 11.0711 16.6067C11.0203 16.7284 10.9942 16.859 10.9942 16.9909C10.9942 17.1228 11.0203 17.2534 11.0711 17.3752C11.1219 17.497 11.1963 17.6075 11.29 17.7004C11.383 17.794 11.4936 17.8683 11.6154 17.9191C11.7373 17.9698 11.868 17.9959 12 17.9959C12.132 17.9959 12.2627 17.9698 12.3846 17.9191C12.5064 17.8683 12.617 17.794 12.71 17.7004L17.71 12.7045C17.801 12.6094 17.8724 12.4974 17.92 12.3747C18.02 12.1315 18.02 11.8586 17.92 11.6154Z",
    fill: "url(#paint0_linear_8_725)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8_725",
    x1: 10.8317,
    y1: 17.9959,
    x2: 13.1652,
    y2: 5.99627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44A1FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardArrow);
export default __webpack_public_path__ + "static/media/ForwardArrow.f60013890dc0259fdc361b4615017b09.svg";
export { ForwardRef as ReactComponent };